var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPollogialloBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.95 35.6899C27.68 33.1499 26.45 30.5099 24.32 28.3799C20.02 24.0799 16.01 21.8799 12.01 23.6899C7.29002 25.8299 8.30001 36.8099 12.6 41.0999C15.04 43.5399 18.15 44.7499 21.02 44.7399L38.01 44.6899C40.06 44.6899 41.52 43.0899 43.01 41.6899C44.75 40.0499 48.01 37.3499 48.01 35.1899C48.01 27.1799 36.52 20.6899 28.51 20.6899C25.77 20.6899 24.2 21.4499 22.01 22.7799",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.01 22.69C14.01 22.69 12.33 20.82 11.4 19.2C10.47 17.57 11.15 14.61 11.21 13.52C11.27 12.43 7.61995 11.79 7.23995 12.31C6.65995 13.09 7.25996 13.97 6.25996 14.66C4.97996 15.55 4.41996 14.38 3.00996 14.95C1.59996 15.53 1.62995 19.9 3.23995 19.9C4.84995 19.9 7.46996 21.74 8.00996 22.69C8.54996 23.63 10.01 25.69 10.01 25.69",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.91 17.91C26.57 15.45 24.89 15.03 22.13 15.76C20.05 16.31 18.89 18.2 18.49 21.1",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.99 15.19C23.99 15.19 22.82 13.35 22.26 11.83C21.7 10.31 22.71 7.86996 22.92 6.94996C23.13 6.02996 20.1 4.94996 19.7 5.33996C19.09 5.92996 19.62 6.76996 18.67 7.21996C17.45 7.78996 16.99 6.69996 15.7 6.98996C14.41 7.27996 13.81 11.02 15.19 11.26C16.57 11.49 18.54 13.44 18.86 14.33C19.18 15.22 20.17 16.93 20.17 16.93",
    stroke: "#1C1C1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPollogialloBlack);
export default __webpack_public_path__ + "static/media/ic_pollogiallo_black.51688fbaa9eb0205538da4c32822cb1a.svg";
export { ForwardRef as ReactComponent };